import React, { Suspense, useEffect } from "react";
import {
  xorWith,
  isEmpty,
  isEqual,
  cloneDeep,
  isArray,
  sortBy,
  orderBy,
  capitalize,
} from "lodash";

export { cloneDeep };
export { isArray };
export { sortBy };
export { orderBy };
export { isEmpty };
export { capitalize };

export const waitForElement = (selector) => {
  return new Promise((resolve, reject) => {
    var element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver((mutations) => {
      mutations.forEach(function (mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for (var node of nodes) {
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
};

export const showModal = (modalHtmlId) => {
  waitForElement(modalHtmlId).then(function (element) {
    window.jQuery(modalHtmlId).modal("show");
    window.jQuery(modalHtmlId).css("overflow", "auto");
  });
};

export const hideModal = (modalHtmlId) => {
  waitForElement(modalHtmlId).then(function (element) {
    window.jQuery(modalHtmlId).css("overflow", "hidden");
    window.jQuery(modalHtmlId).modal("hide");
  });
};

export const isArrayEqual = (x, y) => {
  return isEmpty(xorWith(x, y, isEqual));
};

export const importSuspenseWrapper = (options) => {
  if (typeof options !== "object") {
    options = {};
  }

  if (typeof options.componentPath === "undefined") {
    options.componentPath = "./Home";
    options.componentName = "Home";
  }
  if (typeof options.componentName === "undefined") {
    options.componentPath = "./Home";
    options.componentName = "Home";
  }

  const Component =
    process.env.CURRENT_ENV === "PROD"
      ? React.lazy(() =>
        import(
            /* webpackChunkName: "[request]" */
            /* webpackMode: "lazy" */ `${options.componentPath}/${options.componentName}`
        )
      )
      : require(`${options.componentPath}/${options.componentName}`).default;

  if (process.env.CURRENT_ENV === "PROD") {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Component />
      </Suspense>
    );
  } else {
    return <Component />;
  }

  // const Component = require(`${options.componentPath}/${options.componentName}`)
  //   .default;

  // return (
  //   <>
  //     <Component />
  //   </>
  // );
};

export const getExpirationDate = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }

  const jwt = JSON.parse(atob(jwtToken.split(".")[1]));

  // multiply by 1000 to convert seconds into milliseconds
  return (jwt && jwt.exp && jwt.exp * 1000) || null;
};

export const isExpired = (exp) => {
  if (!exp) {
    return false;
  }

  return Date.now() > exp;
};

export const useScript = (url) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export const useScroll = (shouldLoad) => {
  useEffect(() => {
    if (shouldLoad) {
      var scrollPosition = window.scrollY;
      var logoContainer = document.getElementsByTagName("body")[0];
      window.addEventListener('scroll', function () {
        scrollPosition = window.scrollY;

        if (scrollPosition >= 30) {
          logoContainer.classList.add('scrolled');
        } else {
          logoContainer.classList.remove('scrolled');
        }

      });

      /**
      * Easy selector helper function
      */
      const select = (el, all = false) => {
        el = el.trim()
        if (all) {
          return [...document.querySelectorAll(el)]
        } else {
          return document.querySelector(el)
        }
      }

      /**
      *  Easy event listener function
      */
      const on = (type, el, listener, all = false) => {
        let selectEl = select(el, all)
        if (selectEl) {
          if (all) {
            selectEl.forEach(e => e.addEventListener(type, listener))
          } else {
            selectEl.addEventListener(type, listener)
          }
        }
      }

      /**
       * Easy on scroll event listener 
       */
      const onscroll = (el, listener) => {
        el.addEventListener('scroll', listener)
      }

      /**
       * Toggle .header-scrolled class to #header when page is scrolled
       */
      let selectHeader = select('header')
      if (selectHeader) {
        const headerScrolled = () => {
          if (window.scrollY > 50) {
            selectHeader.classList.add('header-scrolled')
          } else {
            selectHeader.classList.remove('header-scrolled')
          }
        }
        window.addEventListener('load', headerScrolled)
        onscroll(document, headerScrolled)
      }

      /**
      * Back to top button
      */
      let backtotop = select('.d-back-to-top')
      if (backtotop) {
        const toggleBacktotop = () => {
          if (window.scrollY > 100) {
            backtotop.classList.add('active')
          } else {
            backtotop.classList.remove('active')
          }
        }
        window.addEventListener('load', toggleBacktotop)
        onscroll(document, toggleBacktotop)
      }

      /**
       * Scroll with ofset on page load with hash links in the url
       */
      window.addEventListener('load', () => {
        if (window.location.hash) {
          if (select(window.location.hash)) {
            scrollto(window.location.hash)
          }
        }
      });

      /**
      * Footer links smooth jump to section
      */
      let footerlinks = select('#footerlinks .scrollto', true)
      const footerlinksJump = () => {
        window.scrollY - 250
        footerlinks.forEach(footerlink => {
          if (!footerlink.hash) return
          let section = select(footerlink.hash)
          if (!section) return
        })
      }
      window.addEventListener('load', footerlinksJump)
      onscroll(document, footerlinksJump)


      /**
       * Scrolls to an element with header offset
       */
      const scrollto = (el) => {
        let header = select('#header')
        let offset = header.offsetHeight

        if (!header.classList.contains('header-scrolled')) {
          offset -= 20
        }

        let elementPos = select(el).offsetTop
        window.scrollTo({
          top: elementPos - offset,
          behavior: 'smooth'
        })
      }

      /**
     * Scrool with ofset on links with a class name .scrollto
     */
      on('click', '.scrollto', function (e) {
        if (select(this.hash)) {
          e.preventDefault()

          let navbar = select('#navbar')
          scrollto(this.hash)
        }
      }, true)
    }
  }, [shouldLoad]);
};
